<template>
  <slot
    v-if="!isReadonly"
    :icon="PlusIcon"
    :disabled="isEditMode"
    label="View"
    :on-click="handleClick"
  />
</template>

<script setup lang="ts">
import { computed, inject, markRaw } from 'vue'
import { useRouter } from 'vue-router'

import { ReadonlyMode, Widget } from '@types'

import { READONLY_MODE, ROUTE_NAME } from '@/const'
import { CUSTOM_VIEW_NAME } from '../utils/const'

import { generateSlug } from './utils/helpers'

import { useDashboardsStore } from '@/store/dashboards'
import { useModalsStore } from '@/store/modals'

import { PlusIcon } from '@heroicons/vue/24/outline'
import AddViewDialog from './AddViewDialog.vue'

const router = useRouter()

const dashboardsStore = useDashboardsStore()
const modalsStore = useModalsStore()

const isReadonly = inject<ReadonlyMode>(READONLY_MODE)

const isEditMode = computed(() => dashboardsStore.getEditMode)

const handleClick = () => {
  const modalInstance = modalsStore.init(
    'AddViewDialog',
    markRaw(AddViewDialog),
  )
  modalInstance?.open(modalsStore.getZIndex(), {
    onClick: async (widgets: Widget[], name: string, slugValue?: string, useAI?: boolean) => {
      const index = dashboardsStore.getList?.filter(item =>
        new RegExp(`^${name}(\\s\\d+)?$`).test(item.name),
      )?.length
      const dublicate = dashboardsStore.getList?.find(
        item => item.slug === slugValue,
      )
      const slug = dublicate ? generateSlug() : slugValue || generateSlug()
      await dashboardsStore.store({
        id: '',
        name: `${name}${index ? ` ${index}` : ''}`,
        slug,
        widgets,
      })
      router.push({ name: ROUTE_NAME.DASHBOARDS_DASHBOARD, params: { slug } })
      if (name === CUSTOM_VIEW_NAME) {
        dashboardsStore.setEditMode(true)
        dashboardsStore.setAIEnabled(!!useAI)
      }
    },
  })
}
</script>
